import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import PageNotFound from '../../modules/404/PageNotFound'
import FallbackCards from '../../modules/helpers/FallbackCards'
import PrincipalContactoResumen from '../../modules/homeout/principal/components/PrincipalContactoResumen'
import HomeOutValorFactura from '../../modules/homeout/valor-factura/screens/HomeOutValorFactura'

const RouterOutValorFactura = () => {

    return (
        <>
            <Suspense fallback={<FallbackCards />}>
                <Routes>
                    <Route path='/' element={<HomeOutValorFactura />} />
                    <Route path='/404' element={<PageNotFound />} />
                    <Route path='*' element={<Navigate to="/404" />} />
                </Routes>

                {window.location.pathname !== "/valor-factura" && < PrincipalContactoResumen />}
            </Suspense>
        </>
    )

}

export default RouterOutValorFactura